module.exports = __webpack_public_path__ + "static/media/gaming17.dd9f27e9.webp";